import script from "./SignUpBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpBlock.vue?vue&type=script&setup=true&lang=ts"

import "./SignUpBlock.vue?vue&type=style&index=0&id=6c624af0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c624af0"]])

export default __exports__